export interface NotificationPagination {
  currentPageNumber: number;
  totalNotifications: number;
  totalPages: number;
  pageSize: number;
}

export function getInitialNotificationPagination(): NotificationPagination {
  return {
    currentPageNumber: 1,
    totalNotifications: 0,
    totalPages: 1,
    pageSize: 10,
  };
}
